/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
import type { Scorecard } from './Scorecard.js';
import {
    ScorecardFromJSON,
    ScorecardFromJSONTyped,
    ScorecardToJSON,
} from './Scorecard.js';

/**
 * 
 * @export
 * @interface GetScorecardResponse
 */
export interface GetScorecardResponse {
    /**
     * 
     * @type {Scorecard}
     * @memberof GetScorecardResponse
     */
    data?: Scorecard;
    /**
     * 
     * @type {number}
     * @memberof GetScorecardResponse
     */
    totalRecords?: number;
    /**
     * 
     * @type {number}
     * @memberof GetScorecardResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof GetScorecardResponse
     */
    pages?: number;
    /**
     * 
     * @type {Array<Error>}
     * @memberof GetScorecardResponse
     */
    errors?: Array<Error>;
}

/**
 * Check if a given object implements the GetScorecardResponse interface.
 */
export function instanceOfGetScorecardResponse(value: object): boolean {
    return true;
}

export function GetScorecardResponseFromJSON(json: any): GetScorecardResponse {
    return GetScorecardResponseFromJSONTyped(json, false);
}

export function GetScorecardResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetScorecardResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ScorecardFromJSON(json['data']),
        'totalRecords': json['totalRecords'] == null ? undefined : json['totalRecords'],
        'page': json['page'] == null ? undefined : json['page'],
        'pages': json['pages'] == null ? undefined : json['pages'],
        'errors': json['errors'] == null ? undefined : json['errors'],
    };
}

export function GetScorecardResponseToJSON(value?: GetScorecardResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'data': ScorecardToJSON(value['data']),
        'totalRecords': value['totalRecords'],
        'page': value['page'],
        'pages': value['pages'],
        'errors': value['errors'],
    };
}

